import React from 'react'
const SignoutOidc = () => {

    return (
        <div>
            You have been signed out.  Please close your browser
        </div>
    );
}

export default SignoutOidc